import { defineAsyncComponent } from 'vue';

export const LazyFileUploadModal = defineAsyncComponent(() => import('./components/File/UploadModal.vue'));
